<template>
    <div class="text-center">
        <v-card>
            <h3>

            <!--Etape {{etape}}: Paiement-->
            {{$storeCandidature.langueFormulaire == 'en' ? 'Step' : 'Etape'}} {{etape}}: {{$storeCandidature.langueFormulaire == 'en' ? 'Payment' : 'Paiement'}}
            </h3>
            <div v-if="$storeCandidature.sasCandidature.NCheque && $storeCandidature.sasCandidature.NCheque !=''">
            </div>

            <div v-if="$storeCandidature.sasCandidature.PaiementRealise || !$storeCandidature.paiemenyDto.MontantPaiement || $storeCandidature.paiemenyDto.MontantPaiement == 0">
                <div class="green--text font-weight-black">
                    {{$storeCandidature.langueFormulaire == 'en' ? 'Payment validated' : 'Paiement validé'}}
                </div>
                <v-icon x-large color="green darken-2">done_outline</v-icon>
            </div>
            <div v-if="!$storeCandidature.sasCandidature.PaiementRealise && $storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement >= 1
             && $storeCandidature.sasCandidature.ModePaiement && $storeCandidature.sasCandidature.ModePaiement.Id == $storeCandidature.configurationClient.ModePaiementCbId">
                <div class="red--text font-weight-black">
                    {{$storeCandidature.langueFormulaire == 'en' ? 'Payment not made' : 'Paiement non réalisé'}}
                </div>
                <v-icon x-large color="red darken-2">cancel</v-icon>
            </div>
            <div v-if="!$storeCandidature.sasCandidature.PaiementRealise && $storeCandidature.paiemenyDto.MontantPaiement && $storeCandidature.paiemenyDto.MontantPaiement >= 1
             && ($storeCandidature.sasCandidature.ModePaiement && $storeCandidature.sasCandidature.ModePaiement.Id == $storeCandidature.configurationClient.ModePaiementChequeId || $storeCandidature.sasCandidature.ModePaiement && $storeCandidature.sasCandidature.ModePaiement.Id == $storeCandidature.configurationClient.ModePaiementVirementId)">
                <div class="orange--text font-weight-black">
                    {{$storeCandidature.langueFormulaire == 'en' ? 'Your payment is pending validation' : 'Votre paiement est en attente de validation par l\'école'}}
                </div>
                <v-icon x-large color="orange darken-2">timer</v-icon>
            </div>
            <div>
                <v-layout xs12 pt-1>
                    <v-flex xs4></v-flex>
                    <v-flex xs4 pl-5 v-if="!$storeCandidature.sasCandidature.PaiementRealise && $storeCandidature.sasCandidature.ModePaiement && $storeCandidature.sasCandidature.ModePaiement.Id == $storeCandidature.configurationClient.ModePaiementChequeId">
                        <v-text-field readonly label="Numero de chèque" placeholder=" " :value="$storeCandidature.sasCandidature.NCheque"></v-text-field>
                    </v-flex>
                    <v-flex xs4 pl-5 v-if="!$storeCandidature.sasCandidature.PaiementRealise && $storeCandidature.sasCandidature.ModePaiement && $storeCandidature.sasCandidature.ModePaiement.Id == $storeCandidature.configurationClient.ModePaiementVirementId">
                        {{$storeCandidature.langueFormulaire == 'en' ? 'Your payment will be validated upon receipt of the transfer by the school' : 'Votre paiement sera validé dès réception du virement par l\'école'}}
                    </v-flex>
                </v-layout>
            </div>
        </v-card>
    </div>
</template>
<script>
    export default {
        props: {
            etape: {
                default: 5
            }
        },
    }
</script>
<style scoped>
</style>
